import { getToken, setToken } from "@/utils/libs"
import { userLogin,getUserInfo} from "@/api/system"
import { setStore, getStore, removeStore } from '@/utils/store'
import { getAssess } from "@/utils/assess"

export default {
    state: {
        token: getToken(),
        userID: "",
        userName: "",
        isLock: getStore({ name: "isLock" }) || false,
        lockPasswd: getStore({ name: 'lockPasswd' }) || '',
        userInfo:{}
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
            setToken(token)
        },
        setUserID(state, userID) {
            state.userID = userID
        },
        setUserName(state, userName) {
            state.userName = userName;
        },
        setIsLock(state, isLock) {
            state.isLock = true;
            setStore({
                name: 'isLock',
                content: state.isLock,
            })
        },
        setLockPsw(state, psw) {
            state.lockPasswd = psw;
            setStore({
                name: "lockPasswd",
                content: state.lockPasswd
            })
        },
        clearLock: (state, action) => {
            state.isLock = false
            state.lockPasswd = ''
            removeStore({
                name: 'lockPasswd'
            })
            removeStore({
                name: 'isLock'
            })
        },
        setUserInfo(state,info){
            state.userInfo=info;
        }

    },
    actions: {
        // 用户登录
        handleLogin({ commit }, form) {
            return new Promise((resolve, reject) => {
                userLogin(form).then(res => {
                    const data = res.data;
                    if (res.status) {
                        commit('setToken', data.token)
                        resolve()
                    } else {
                        reject(res)
                    }
                }).catch(err => {
                })
            })
        },
        // 退出登录
        handleLogOut({ state, commit }) {
            return new Promise((resolve, reject) => {
               commit("clearLock");
                commit("setToken", "");
                commit("setUserInfo",{});
                resolve();
            })
        },
        //上锁
        handleIsLock({ state, commit }, psw) {
            console.log(psw)
            return new Promise((resolve, reject) => {
                commit("setIsLock");
                commit("setLockPsw", psw)
                resolve();
            })
        },
        //解锁
        handleSetLock({ state, commit }) {
            return new Promise((resolve, reject) => {
                commit("clearLock");
                resolve();
            })
        },
        //保存可访问权限列表
        handleUserInfo({state,commit},info){
            return new Promise((resolve, reject) => {
                getUserInfo().then(res=>{
                    if(res.status){
                      if(res.data.admin_id!==1){
                        let menu =JSON.parse(res.data.menu||[]);
                        res.data.menu = getAssess(menu);
                      }  
                        commit("setUserInfo",res.data);
                        resolve();
                    }else{
                        reject(res)
                    }
                }).catch(err=>{
                    reject({
                        status: -1,
                        info: err.message,
                    })
                })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js